export function getDaysSinceDate(date: string | undefined) {
    if (!date) return undefined

    const inputDate = new Date(date)
    const today = new Date()
    const timeDifference = today.getTime() - inputDate.getTime()
    return Math.round(timeDifference / (1000 * 60 * 60 * 24))
  }

export function getLastPlayedDays(lastPlayedSingles: string | undefined, lastPlayedDoubles: string | undefined) {
    if(!lastPlayedSingles && !lastPlayedDoubles) return undefined

    const sinceDoubles = getDaysSinceDate(lastPlayedDoubles)
    const sinceSingles = getDaysSinceDate(lastPlayedSingles)

    return sinceDoubles && sinceSingles ? Math.min(sinceDoubles, sinceSingles) : sinceDoubles || sinceSingles

  }